import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let OneMainPagesSectionThunk = createAsyncThunk(
  "pages/OneMainPagesSectionThunk",
  async (arg, ThunkApi) => {
    let { rejectWithValue } = ThunkApi;
    try {
      let url = `/api/admin/${arg?.type}${arg?.id?"/"+arg?.id:""}`;

      let res = await axios.get(url);

      return res.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
